export default {
  loading: 'Chargement...',
  failed: 'Recherche indisponible',
  changeCountry: 'Changer de pays',
};
